import { themeVariables } from 'theme/globalStyles';

export const VARIANTS = {
  CRITICAL: themeVariables.background.critical,
  WARNING: themeVariables.icon.warning,
  SUCCESS: themeVariables.icon.success,
  INFORMATIONAL: themeVariables.icon.informational,
  MUTED: themeVariables.icon.default,
} as const;
